export default __webpack_public_path__ + "static/media/1_0158.a0bb8154.webp";